import { render, staticRenderFns } from "./UserInput.vue?vue&type=template&id=1112db42&scoped=true&"
import script from "./UserInput.vue?vue&type=script&lang=js&"
export * from "./UserInput.vue?vue&type=script&lang=js&"
import style0 from "./UserInput.vue?vue&type=style&index=0&id=1112db42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1112db42",
  null
  
)

export default component.exports